import * as React from "react";
import { forwardRef } from "react";
const TruckBedCoverIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4.05 3.886A2.25 2.25 0 0 1 6.3 6.133v.503h11.993l.08.004a.75.75 0 0 1 .482.25l3.266 3.7a.75.75 0 0 1 .188.496v4.608c0 1.394-1.27 2.345-2.597 2.345h-2.48a3.75 3.75 0 0 1-7.451.123H2.5a.75.75 0 1 1 0-1.5h2.3V6.133a.748.748 0 0 0-.75-.747H2.5a.75.75 0 1 1 0-1.5h1.55zm9.45 11.55a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 1 0 0-4.5zm-7.2 1.227h3.5c.031 0 .061.002.091.006a3.75 3.75 0 0 1 7.18-.129h2.642c.712 0 1.096-.478 1.097-.845v-3.858H6.3v4.826zm0-6.326h1.887l-1.66-2.2H6.3v2.2zm3.765-.002v.002h1.921l-1.66-2.2h-1.92l1.658 2.198zm7.896.002h1.936l-1.942-2.2h-1.936l1.941 2.2zm-4.096-.002.001.002h2.094l-1.941-2.2h-1.812l1.658 2.198z"
}));
const ForwardRef = forwardRef(TruckBedCoverIcon);
export default ForwardRef;